import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'fullNameOfUser'
})
export class FullNameOfUserPipe implements PipeTransform {
    transform(user: any): string {
        if (!user || typeof (user) === 'string') return '';
        return `${user.first_name} ${user.last_name || ''}`;
    }
}